module.exports = __webpack_public_path__ + "static/imc-a67a9410271edf3d35d7f3e122fcc896.png";